<template>
  <div class="payroll-tabs-bar">
    <div class="payroll-tabs">

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/payroll/dashboard')"
        class="payroll-tab"
        :class="isActive(['Payroll Dashboard']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="chart-pie" class="tab-icon" />
        Dashboard
      </router-link>

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/payroll-periods')"
        class="payroll-tab"
        :class="isActive(['Payroll Periods']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="calendar-alt" class="tab-icon" />
        Payroll Periods
      </router-link>

      <router-link
        v-if="permission.view_payroll == 1"
        :to="$url('/payroll-history')"
        class="payroll-tab"
        :class="isActive(['Payroll History']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="file-invoice-dollar" class="tab-icon" />
        Payslip History
      </router-link>

      <router-link
        v-if="permission.process_payroll == 1"
        :to="$url('/payroll-additional-earnings')"
        class="payroll-tab"
        :class="isActive(['Payroll Additional Earning']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="plus-circle" class="tab-icon" />
        Additional Earnings
      </router-link>

      <router-link
        v-if="permission.process_payroll == 1"
        :to="$url('/payroll-additional-deductions')"
        class="payroll-tab"
        :class="isActive(['Payroll Additional Deduction']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="minus-circle" class="tab-icon" />
        Additional Deductions
      </router-link>
      
      <router-link
        v-if="permission.process_payroll == 1"
        :to="$url('/manage-paygrade')"
        class="payroll-tab"
        :class="isActive(['Manage Paygrade']) ? 'payroll-tab--active' : ''"
      >
        <font-awesome-icon icon="minus-circle" class="tab-icon" />
        Manage Paygrade
      </router-link>

    </div>
  </div>
</template>

<script>
import { computed } from '@vue/runtime-core';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store      = useStore();
    const router     = useRouter();
    const permission = computed(() => store.state.getCurrentUserPermission);
    const isActive   = (names) => names.includes(router.currentRoute.value.name);
    return { permission, isActive };
  },
};
</script>

<style scoped>
.payroll-tabs-bar {
  background: #fff;
  border-bottom: 1px solid #e4eaf2;
  padding: 0 20px;
  margin-bottom: 20px;
}

.payroll-tabs {
  display: flex;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.payroll-tabs::-webkit-scrollbar { display: none; }

.payroll-tab {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 13px 16px;
  font-size: 13.5px;
  font-weight: 500;
  color: #7a90b0;
  text-decoration: none;
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 0.15s, border-color 0.15s;
  margin-bottom: -1px;
  cursor: pointer;
}
.payroll-tab:hover { color: #004AAD; text-decoration: none; }

.payroll-tab--active {
  color: #004AAD !important;
  border-bottom-color: #004AAD !important;
  font-weight: 600;
}

.tab-icon { font-size: 13px; opacity: 0.85; }

@media (max-width: 576px) {
  .payroll-tabs-bar { padding: 0 12px; }
  .payroll-tab      { padding: 11px 12px; font-size: 13px; gap: 5px; }
}
</style>